export const skillsData = [
  {
    label: "WEB DEVELOPMENT",
    data: [
      {
        skillName: "HTML",
        percentage: "90",
      },
      {
        skillName: "CSS",
        percentage: "50",
      },
      {
        skillName: "JAVASCRIPT",
        percentage: "80",
      },
      {
        skillName: "REACT",
        percentage: "90"
      },

      {
        skillName: "ANGULAR",
        percentage: "40"
      },
      {
        skillName: "NODE JS",
        percentage: "54",
      },
     
      {
        skillName: "EXPRESS",
        percentage: "60",
      },
    ],
  },

  {
    label: "DATABASES",
    data: [
      {
        skillName: "SQL",
        percentage: "70",
      },
      {
        skillName: "MONGO DB",
        percentage: "80",
      },
    ],
  },

  {
    label: "CODING",
    data: [
      {
        skillName: "DSA",
        percentage: "80",
      },
      {
        skillName: "COMPETITIVE PROGRAMMING",
        percentage: "65",
      },
      {
        skillName: "C++",
        percentage: "95",
      },
      {
        skillName: "PYTHON",
        percentage: "40",
      },
    ],
  },

  {
    label: "OTHERS",
    data: [
      {
        skillName: "MACHINE LEARNING",
        percentage: "51",
      },
      {
        skillName: "APP DEVELOPMENT",
        percentage: "40",
      },
      {
        skillName: "GAME DEVELOPMENT",
        percentage: "50",
      },
      {
        skillName: "GIT",
        percentage: "62",
      },
      {
        skillName: "FLUTTER/DART",
        percentage: "34",
      },
      
    ],
  },
];
